__turbopack_context__.v({
  "leader-star": "styles-module__tOT5xq__leader-star",
  "member-link-span": "styles-module__tOT5xq__member-link-span",
  "profile-image": "styles-module__tOT5xq__profile-image",
  "profile-image-wrapper": "styles-module__tOT5xq__profile-image-wrapper",
  "shadow-wrapper": "styles-module__tOT5xq__shadow-wrapper",
  "text-wrapper": "styles-module__tOT5xq__text-wrapper",
});
